/* eslint-disable no-console */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export var DebugLevels = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3
};
var currentDebugLevel = DebugLevels.DEBUG;
var levelsByMarker = {};
/**
 * Adds overrides by marker. To clear an existing value use { theMarker: undefined }
 */
export function addLevelsByMarker(overrides) {
    if (!overrides) {
        // guard against null input for JS usage
        return;
    }
    Object.assign(levelsByMarker, overrides);
}
/**
 * LogClient implementation that allows logging to multiple places by delegating to other clients.
 * A practical use case is logging to both console and server in development regions.
 **/
var CompositeLogClient = /** @class */ (function () {
    function CompositeLogClient() {
        var _this = this;
        var clients = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            clients[_i] = arguments[_i];
        }
        this.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.clients.forEach(function (client) { return client.debug.apply(client, __spreadArray([], __read(args))); });
        };
        this.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.clients.forEach(function (client) { return client.info.apply(client, __spreadArray([], __read(args))); });
        };
        this.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.clients.forEach(function (client) { return client.warn.apply(client, __spreadArray([], __read(args))); });
        };
        this.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.clients.forEach(function (client) { return client.error.apply(client, __spreadArray([], __read(args))); });
        };
        this.clients = clients;
    }
    return CompositeLogClient;
}());
export { CompositeLogClient };
/** Simple Log Client that writes to console **/
var ConsoleLogClient = /** @class */ (function () {
    function ConsoleLogClient() {
        this.debug = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _b = __read(args), marker = _b[0], rest = _b.slice(1);
            if (typeof window === 'undefined') {
                console.log.apply(console, __spreadArray(["[" + marker + "]: "], __read(rest)));
            }
            else {
                (_a = window.console).log.apply(_a, __spreadArray(["[" + marker + "]: "], __read(rest)));
            }
        };
        this.info = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _b = __read(args), marker = _b[0], rest = _b.slice(1);
            if (typeof window === 'undefined') {
                console.info.apply(console, __spreadArray(["[" + marker + "]: "], __read(rest)));
            }
            else {
                (_a = window.console).info.apply(_a, __spreadArray(["[" + marker + "]: "], __read(rest)));
            }
        };
        this.warn = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _b = __read(args), marker = _b[0], rest = _b.slice(1);
            if (typeof window === 'undefined') {
                console.warn.apply(console, __spreadArray(["[" + marker + "]: "], __read(rest)));
            }
            else {
                (_a = window.console).warn.apply(_a, __spreadArray(["[" + marker + "]: "], __read(rest)));
            }
        };
        this.error = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _b = __read(args), marker = _b[0], rest = _b.slice(1);
            if (typeof window === 'undefined') {
                console.error.apply(console, __spreadArray(["[" + marker + "]: "], __read(rest)));
            }
            else {
                (_a = window.console).error.apply(_a, __spreadArray(["[" + marker + "]: "], __read(rest)));
            }
        };
    }
    return ConsoleLogClient;
}());
export { ConsoleLogClient };
var currentLogClient = new ConsoleLogClient();
/**
 * Logger class used to add application logging to modules..
 * Typically create a new instance per module / source file as follows
 * const LOG = new Logger('MyModuleName');
 * Then use in the module using LOG.debug/warn/error
 **/
var Logger = /** @class */ (function () {
    function Logger(marker, level) {
        this.marker = marker;
        this.debugLevel = level;
    }
    Logger.prototype.setLogLevel = function (level) {
        this.debugLevel = level;
    };
    Logger.prototype.getEffectiveLogLevel = function () {
        if (this.debugLevel || this.debugLevel === 0) {
            return this.debugLevel;
        }
        if (levelsByMarker[this.marker] || levelsByMarker[this.marker] === 0) {
            return levelsByMarker[this.marker];
        }
        return currentDebugLevel;
    };
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.getEffectiveLogLevel() <= DebugLevels.DEBUG) {
            currentLogClient.debug.apply(currentLogClient, __spreadArray([this.marker], __read(args)));
        }
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.getEffectiveLogLevel() <= DebugLevels.INFO) {
            currentLogClient.info.apply(currentLogClient, __spreadArray([this.marker], __read(args)));
        }
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.getEffectiveLogLevel() <= DebugLevels.WARN) {
            currentLogClient.warn.apply(currentLogClient, __spreadArray([this.marker], __read(args)));
        }
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.getEffectiveLogLevel() <= DebugLevels.ERROR) {
            currentLogClient.error.apply(currentLogClient, __spreadArray([this.marker], __read(args)));
        }
    };
    return Logger;
}());
export default Logger;
/* Set Global Debug Level for all logger instances */
export function setDebugLevel(debugLevel) {
    currentDebugLevel = debugLevel;
}
/* Get current debug level */
export function getDebugLevel() {
    return currentDebugLevel;
}
/* Set Global LogClient for all logger instances */
export function setLogClient(logClient) {
    currentLogClient = logClient;
}
/* Get current log client */
export function getLogClient() {
    return currentLogClient;
}
